import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { TaskQL } from '../../providers/tasks/models';
import { Provider } from '../../providers/providers/models';
import { TasksProvider } from '../../providers/tasks/tasks';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LocationProvider } from '../../providers/location/location';
import { ProvidersProvider } from '../../providers/providers/providers';
import { TaskNotesPage } from '../task-notes/task-notes';
import { TaskInvoicePage } from '../task-invoice/task-invoice';
import { UtilsProvider } from '../../providers/utils/utils';

declare let google;

@IonicPage()
@Component({
  selector: 'page-tasks-complete-detail',
  templateUrl: 'tasks-complete-detail.html'
})
export class TasksCompleteDetailPage {
  @ViewChild('map') mapElement: ElementRef;
  public task: TaskQL;
  private map: any;
  private myLocation: any;
  private customer: any;
  private customerDetail: boolean = false;
  private taskData: any;
  private loading: boolean = true;
  private providers: Provider[];
  private deviceReplace: any = false;
  private isRepair: boolean = false;
  private hasInvoice: boolean = false;
  private isScheduler: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public tasksProvider: TasksProvider,
    private iab: InAppBrowser,
    private plt: Platform,
    private locationProvider: LocationProvider,
    private providersProvider: ProvidersProvider,
    private utilsProvider: UtilsProvider,
  ) {
    this.task = this.navParams.get('task');
  }
  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.providersProvider.getProviders().subscribe(providersResult => {
      this.providers = providersResult;
      this.taskData = this.tasksProvider.getTaskData(this.task.id);
      this.isRepair = this.task.type.toLowerCase() == 'repair';

      if (this.taskData.deviceReplace)
        this.deviceReplace = this.taskData.deviceReplace;

      this.loading = false;
      setTimeout(() => {
        this.map = this.locationProvider.loadMap(this.map, [this.task], true, this.mapElement)
      }, 100);
    });
    this.hasInvoiceFn();
    this.isSchedulerCheck();
  }

  ngOnChanges() {
    console.log('Model changed!!:', this.deviceReplace);
  }

  openMap() {
    let lat = this.task.address.latitude;
    let lng = this.task.address.longitude;
    let latlng = lat + ',' + lng;
    let url = '';
    if (!this.plt.is('cordova')) {
      // this will be used for browsers if we ever want to convert to a website
      url = 'http://maps.google.com?ll=' + latlng; //+encodeURIComponent(address_str);
    } else if (this.plt.is('ios')) {
      url = 'http://maps.apple.com/maps?ll=' + latlng; //+encodeURIComponent(address_str);
    } else if (this.plt.is('android') || this.plt.is('windows')) {
      url = 'geo:?q=' + latlng; //+encodeURIComponent(address_str);
    }
    this.iab.create(url, '_system', 'location=true');
  }

  openImage(url) {
    this.iab.create(url, '_system', 'location=true');
  }
  isSchedulerCheck() {
    const userData = this.utilsProvider.getUserData();
    this.isScheduler = userData.isSchedular;
  }
  hasInvoiceFn() {
    this.utilsProvider.hasInvoice(this.task.id).subscribe(
      response => {
        if (response === null) {
          this.hasInvoice = false;
        } else {
          this.hasInvoice = true;
        }
      },
      error => {
        this.hasInvoice = false;
      },
    );
    
  }

  openModule(type) {
    let module;
    let extras = { isrepair: false, isreplace: false };
    switch (type) {
      case 'notes':
        module = TaskNotesPage;
        break;
      case 'invoice':
        module = TaskInvoicePage;
        break;
      default:
        break;
    }
    if (module) {
      this.navCtrl.push(module, {
        task: this.task,
        customer: this.customer,
        extras
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks-complete-detail/tasks-complete-detail.ts